<template>
	<div class="loginHome flex align-center justify-center">
			<img src="../../assets/images/pic_login.png" >
			<div class="loginBox">
				<p class="title">用户登录</p>
				<el-input
				  placeholder="请输入您的登录名"
				  v-model="username"
				  clearable  @keyup.enter.native="login">
				</el-input>
				<el-input
				  placeholder="请输入您的密码"
				  v-model="userpass"
				  show-password
				  clearable  @keyup.enter.native="login">
				</el-input>
				<p class="btn" @click="login">登 录</p>
				<p class="content">还没有账号？<span @click="$router.push('/register')">去注册</span></p>
			</div>
	</div>
</template>

<script>
	import navheader from '../../components/navheader.vue'
	import footeritem from '../../components/footeritem.vue'
	import axios from 'axios'
	import '../../assets/css/index.less'
	import '../../assets/css/fuWu.less';
	export default {
		name: 'Pdf',
		components: {
			navheader,
			footeritem
		},
		data() {
			return {
				username:'',
				userpass:''
			};
		},
		methods: {
			// 司法鉴定人列表
			login() {
			    var that = this
			    var params = new URLSearchParams();
			    axios.post('/system/customer/login', {'username':that.username,'password':that.userpass},{headers:{'Content-Type':'application/json;charset=UTF-8'}}).then(res => {
			     if (res.data.code == 200) {
                     this.$message({
                         message: res.data.msg,
                         type: 'success'
                     });
					 localStorage.setItem('token',res.data.data.token)
					 that.$router.push('/grht')
			      // this.personBox = res.data.rows.slice(0,6)
			     }else {
                     this.$message.error(res.data.msg);
                 }
			    }, err => {})
			   }
		},
		created() {

		},
		mounted() {
			let that = this;
		},
	};
</script>

<style lang="less" scoped>
.loginHome {
  background: #a9d1f8;
  height: calc(100vh - 150px);
  overflow: hidden;
}
	.loginBox{
		width: 400px;
		height: 450px;
		background: #ffffff;
		margin-left: 184px;
		padding: 70px 25px;
		box-sizing: border-box;
		.title{
			width: 100%;
			font-size: 24px;
			font-family: Microsoft YaHei, Microsoft YaHei-Bold;
			font-weight: 700;
			text-align: center;
			color: #0065dc;
		}
		.el-input{
			border: none;
			margin-top: 20px;
		}
		.btn{
			width: 100%;
			height: 50px;
			line-height: 50px;
			opacity: 1;
			background: #0065dc;
			font-size: 18px;
			font-family: Microsoft YaHei, Microsoft YaHei-Bold;
			font-weight: 700;
			text-align: center;
			color: #ffffff;
			cursor: pointer;
			margin-top: 55px;
		}
		.content{
			width: 100%;
			margin-top: 17px;
			font-size: 14px;
			font-family: Microsoft YaHei, Microsoft YaHei-Bold;
			font-weight: 700;
			text-align: center;
			color: #666666;
			text-align: left;
			span{
				color: #0065dc;
				margin-left: 10px;
				cursor: pointer;
			}
		}
	}
</style>
